import React from "react";
import "./../css/footer.scss";
import logo2 from "./../img/logo2.svg";
import { Container, Row, Col } from "react-bootstrap";
// import ScrollUpButton from "react-scroll-up-button";

const FrontFooter = () => {
  return (
    <div className="wrap-footer">
      <Container>
        <Row>
          <Col xl="6" lg="6" md="12" sm="12">
            <div>
              <img src={logo2} title="" alt="" className="logoFooter" />
              <div className="divFooterText">
                Ми є компанією з розробки програмного забезпечення, яка допомагає страховому бізнесу створювати та покращувати їхні програмні продукти.
              </div>
              <div className="divCopyFooter">
                Copyright © {(new Date().getFullYear())} SAGAX
                {/* ©{(new Date().getFullYear())}&nbsp;&nbsp;&nbsp;&nbsp;Privacy Policy */}
              </div>
            </div>
          </Col>
          <Col xl="2" lg="2" className="d-xl-block d-lg-block d-none">
            <p className="pBoldFooter">Продукти</p>
            <p className="pNormalFooter"><a href="/ua/product/sagacity-insurance-api">Платформа страхування Api</a></p>
            <p className="pNormalFooter"><a href="/ua/product/online-insurance-products">Страховий інтернет-магазин</a></p>
          </Col>
          <Col xl="2" lg="2" className="d-xl-block d-lg-block d-none">
            <p className="pBoldFooter">Приклади рішень</p>
            <p className="pNormalFooter"><a href="/ua/case-studies/chat-bots">Чат-боти</a></p>
            <p className="pNormalFooter"><a href="/ua/case-studies/online-store">Онлайн-магазин</a></p>
            <p className="pNormalFooter"><a href="/ua/case-studies/api-sales-tool">API - Інструмент продажів</a></p>
            <p className="pNormalFooter"><a href="/ua/case-studies/online-agent">Онлайн-агент</a></p>
          </Col>
          <Col xl="2" lg="2" className="d-xl-block d-lg-block d-none">
            <p className="pBoldFooter"><a href="/ua/company">Компанія</a></p>
            <p className="pBoldFooter"><a href="/ua/careers">Кар'єра</a></p>
            <p className="pBoldFooter"><a href="/ua/blogs">Блог</a></p>
            <p className="pBoldFooter"><a href="/ua/contact">Контакти</a></p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default FrontFooter;
